"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerType = exports.TimerEventDefinition = exports.TerminateEventDefinition = exports.SignalEventDefinition = exports.MessageEventDefinition = exports.LinkEventDefinition = exports.ErrorEventDefinition = exports.EventDefinition = exports.Event = void 0;
const Constants_1 = require("../Constants");
const index_1 = require("../Base/index");
/**
 * The base class for all events.
 */
class Event extends index_1.FlowNode {
    /**
     * Gets the type of the Event (Message, Signal, etc.)
     */
    get eventType() {
        const eventIsMessageEvent = this.messageEventDefinition !== undefined;
        if (eventIsMessageEvent) {
            return Constants_1.EventType.messageEvent;
        }
        const eventIsSignalEvent = this.signalEventDefinition !== undefined;
        if (eventIsSignalEvent) {
            return Constants_1.EventType.signalEvent;
        }
        return undefined;
    }
}
exports.Event = Event;
/**
 * The base class of all event definitions.
 */
class EventDefinition extends index_1.BaseElement {
}
exports.EventDefinition = EventDefinition;
/**
 * Contains the definition for an ErrorEvent.
 */
class ErrorEventDefinition extends EventDefinition {
}
exports.ErrorEventDefinition = ErrorEventDefinition;
/**
 * Contains the definition for a LinkEvent.
 */
class LinkEventDefinition extends EventDefinition {
    constructor(linkName) {
        super();
        this.name = linkName;
    }
}
exports.LinkEventDefinition = LinkEventDefinition;
/**
 * Contains the definition for a MessageEvent.
 */
class MessageEventDefinition extends EventDefinition {
}
exports.MessageEventDefinition = MessageEventDefinition;
/**
 * Contains the definition for a SignalEvent.
 */
class SignalEventDefinition extends EventDefinition {
}
exports.SignalEventDefinition = SignalEventDefinition;
/**
 * Contains the definition for a TerminateEndEvent.
 */
class TerminateEventDefinition extends EventDefinition {
}
exports.TerminateEventDefinition = TerminateEventDefinition;
/**
 * Contains the definition for a TimerEvent.
 */
class TimerEventDefinition extends EventDefinition {
    constructor() {
        super(...arguments);
        this.enabled = true;
    }
}
exports.TimerEventDefinition = TimerEventDefinition;
/**
 * Contains all timer types that are currently supported.
 */
var TimerType;
(function (TimerType) {
    TimerType[TimerType["timeCycle"] = 0] = "timeCycle";
    TimerType[TimerType["timeDate"] = 1] = "timeDate";
    TimerType[TimerType["timeDuration"] = 2] = "timeDuration";
})(TimerType = exports.TimerType || (exports.TimerType = {}));
//# sourceMappingURL=EventBase.js.map